import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { reportspdf } from '../../../models/reportspdf';
import { PromiseResult } from '../../../models/PromiseResult';
import { past_medical_history_data } from '../../../models/history';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { TraceClassDecorator } from '@sentry/angular';
import { DateUtilService, moment_duration } from '../../../utilities/date.util.service';
import { formatDate } from '@angular/common';
import { CONSULTATION_TYPES, URLS } from 'src/app/constant/constant';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@Component({
    selector: 'app-doctorreportpdf',
    templateUrl: './doctorreportpdf.component.html',
    styleUrls: [
        './../../../../assets/css/custom-egd-1.css',
        './doctorreportpdf.component.css'
    ]
})
@TraceClassDecorator()
export class DoctorreportpdfComponent implements OnInit, OnDestroy {
    // @Input('patient_guid')
    // patient_guid:string=null;
    // @Input('consultation_id')
    // consultation_id:number=0;

    @Input('data') data: reportspdf;
    @Input() dataId: string;
    guid = null;
    response: PromiseResult;
    consultationid = null;
    isapollodiagnosticsline: boolean = false;
    page;
    guid_string: string = null;
    consultationid_number: number = null;
    history_of_current_illness = '';
    consultation_notes = '';
    is_primary_provider: boolean = false;
    social_history;
    smoking;
    ext;
    alcohol;
    smoking_type = null;
    no_of_packs = '';
    is_uk_country: boolean = false;
    no_of_years_smoked = '';

    year_of_quitting_smoke = null;

    alcohol_type = null;

    drinks_per_week = '';
    apolloDiagnosticsCoupon = '';
    year_of_quitting_alcohol = null;
    gender: string = '';
    medical_history_count: number = 0;
    medical_history: past_medical_history_data[] = [];
    allergy_list: any = [];
    medication_list = [];
    upload_records_data: boolean;
    medication_data = '';
    allergy_data = '';
    family_history_data = '';
    social_history_data = '';
    logo_url: string = '';
    past_medical_history_data = '';
    current_med_problems = '';
    condition_description = '';
    past_medical_surgical_history = '';
    successfull: boolean = false;
    posting: boolean = true;
    consultationcloseddate: Date;
    consultationdate: Date;
    is_gender: boolean = false;
    members = [
        { name: 'Mother', data: [] },
        { name: 'Father', data: [] },
        { name: 'Brother', data: [] },
        { name: 'Sister', data: [] }
    ];
    doctor_name = '';
    specialty = '';
    diet_prefernce: string = "";
    is_signature: boolean = false;
    is_diet_prefernce: boolean = false;
    show_signature: boolean = true;
    gmc_reg_no: string = "";

    constructor(
        public utilitiesService: UtilitiesService,
        private readonly dateUtil: DateUtilService,
        private readonly providerStateService: ProviderStateService
    ) { }

    async ngOnInit() {
        this.posting = true;
        this.is_primary_provider = this.providerStateService.getIsPrimaryProvider();
        if(URLS.IS_UK)
        {
            this.is_uk_country = true;
        }
        this.guid = null;
        this.logo_url = this.data.logoUrl;
        this.consultationid = null;
        this.gmc_reg_no = this.data.consultation.p_consultation_appointment.map((d) => {
            return d.egd_users.doctor_profile.gmc_reg_no
        })
            .join(', ');
        this.show_signature = this.data.consultation.consultation_type_id != 5;
        this.doctor_name = this.data.consultation.p_consultation_appointment
            .map((d) => {
                return d.egd_users.first_name + ' ' + d.egd_users.last_name;
            })
            .join(', ');
        this.specialty = this.data.consultation.p_consultation_appointment
            .map((d) => {
                return d.d_specialty_type.specialty_name;
            })
            .join(', ');
        //     await this.ReportData.getID().subscribe((message) => {
        //
        //       this.guid = message;
        //   });
        //   await this.ReportData.getCID().subscribe((message) => {
        //
        //     this.consultationid = message;
        // });

        // this.guid_string=this.guid.toString();
        // this.consultationid_number=Number(this.consultationid);

        const dage = this.dateUtil.diff(new Date(this.data.patient.date_of_birth), new Date(), moment_duration.years);
        const age = dage + ' Yrs';
        this.page = age;
        if (Boolean(this.data.patient.gender)) {
            this.gender = this.data.patient.gender;
            this.gender =
                this.gender[0].toUpperCase() + this.gender.substr(1).toLowerCase();
            this.is_gender = true;
        }
        else {
            this.gender = "";
            this.is_gender = false;
        }
        // this.consultationcloseddate=this.data.consultation.consultation_closed_date;

        this.data.signature_url = Boolean(this.data.signature_url) ? this.data.signature_url : "";
        this.is_signature = Boolean(this.data.signature_url);
        await this.GetReportspdf();

        this.posting = false;
    }

    async ngOnDestroy() {
        // await this.ReportData.resetID();
        // await this.ReportData.resetCID();
    }

    async yearsDiff(d1, d2) {
        let date1 = new Date(d1);
        let date2 = new Date(d2);
        let yearsDiff = date2.getFullYear() - date1.getFullYear();
        return yearsDiff;
    }

    printReport() {
        window.print();
    }

    isNutritionAndHealthConsultation(): boolean {
        return this.data.consultation.consultation_type_id === CONSULTATION_TYPES.NUTRITION_AND_HEALTH_CONSULTATION;
    }

    async preprocess_familyhistory(raw_familyhistory: any[]) {
        for (const member of this.members) {
            for (const raw_member of raw_familyhistory) {
                if (member.name == raw_member.name) {
                    const temp = [];
                    for (const hist of raw_member.data)
                        temp.push({
                            name: hist
                        });
                    member.data = temp;
                }
            }
        }
    }

    private async GetReportspdf() {
        if (this.data.consultation != null) {
            if (this.isNutritionAndHealthConsultation()) {
                this.data.consultation.diet_consultation_data.final_diet_preference = Boolean(this.data.consultation.diet_consultation_data.other_diet_preferrence) ? this.data.consultation.diet_consultation_data.other_diet_preferrence : this.data.consultation.diet_consultation_data.diet_preferrence?.diet_type;
                if (Boolean(this.data.consultation.diet_consultation_data.final_diet_preference)) {
                    this.is_diet_prefernce = true;
                }
            }

            // data.consultation.consultation_notes
            // this.history_of_current_illness=this.data.consultation.d_consultation_data.history_of_current_illness;
            if (
                this.data.consultation.condition_description != null &&
                this.data.consultation.condition_description.length > 0
            ) {
                this.condition_description =
                    this.data.consultation.condition_description;
            } else if (this.data.consultation.condition_description == null) {
                this.condition_description = 'N/A';
            } else if (
                this.data.consultation.condition_description.length == 0
            ) {
                this.condition_description = 'N/A';
            }

            if (
                this.data.consultation.d_consultation_data
                    .history_of_current_illness != null &&
                this.data.consultation.d_consultation_data
                    .history_of_current_illness.length > 0
            ) {
                this.history_of_current_illness =
                    this.data.consultation.d_consultation_data.history_of_current_illness;
            } else if (
                this.data.consultation.d_consultation_data
                    .history_of_current_illness == null
            ) {
                this.history_of_current_illness = 'N/A';
            } else if (
                this.data.consultation.d_consultation_data
                    .history_of_current_illness.length == 0
            ) {
                this.history_of_current_illness = 'N/A';
            }

            if (
                this.data.consultation.d_consultation_data.consultation_notes !=
                null &&
                this.data.consultation.d_consultation_data.consultation_notes
                    .length > 0
            ) {
                this.consultation_notes =
                    this.data.consultation.d_consultation_data.consultation_notes;
            } else if (
                this.data.consultation.d_consultation_data.consultation_notes ==
                null
            ) {
                this.consultation_notes = 'N/A';
            } else if (
                this.data.consultation.d_consultation_data.consultation_notes
                    .length == 0
            ) {
                this.consultation_notes = 'N/A';
            }
        } else if (this.data.consultation == null) {
            this.condition_description = 'N/A';
            this.history_of_current_illness = 'N/A';
            this.consultation_notes = 'N/A';
        }

        if (this.data.condtion == null) {
            this.current_med_problems = 'N/A';
        } else if (this.data.condtion != null) {
            if (
                this.data.condtion.current_medical_problems != null &&
                this.data.condtion.current_medical_problems.length > 0
            ) {
                this.current_med_problems =
                    this.data.condtion.current_medical_problems;
            } else if (this.data.condtion.current_medical_problems == null) {
                this.current_med_problems = 'N/A';
            } else if (
                this.data.condtion.current_medical_problems.length == 0
            ) {
                this.current_med_problems = 'N/A';
            }
        }
        if (this.data.history == null) {
        } else if (this.data.history != null) {
            this.past_medical_history_data = '';
            if (this.data.history.past_medical_history_data == null) {
                this.past_medical_history_data = 'N/A';
            } else if (
                this.data.history.past_medical_history_data.length == 0
            ) {
                this.past_medical_history_data = 'N/A';
            } else if (this.data.history.past_medical_history_data.length > 0) {
                for (
                    let j = 0;
                    j < this.data.history.past_medical_history_data.length;
                    j++
                ) {
                    if (
                        j == 0 &&
                        j ==
                        this.data.history.past_medical_history_data.length -
                        1
                    ) {
                        this.past_medical_history_data +=
                            this.data.history.past_medical_history_data[j]
                                .name + '. \n';
                    } else if (j == 0) {
                        this.past_medical_history_data +=
                            this.data.history.past_medical_history_data[j].name;
                    } else if (j == this.medical_history.length - 1) {
                        this.past_medical_history_data +=
                            ', ' +
                            this.data.history.past_medical_history_data[j]
                                .name +
                            '. \n';
                    } else
                        this.past_medical_history_data +=
                            ', ' +
                            this.data.history.past_medical_history_data[j].name;
                }
            }
            if (
                this.data.history.past_surgical_history_data != null &&
                this.data.history.past_surgical_history_data.length > 0
            ) {
                this.past_medical_surgical_history =
                    this.data.history.past_surgical_history_data;
            } else if (this.data.history.past_surgical_history_data == null) {
                this.past_medical_surgical_history = 'N/A';
            } else if (
                this.data.history.past_surgical_history_data.length == 0
            ) {
                this.past_medical_surgical_history = 'N/A';
            }

            if (this.data.history.social_history == null) {
                this.social_history_data = 'N/A';
            }

            this.social_history_data = '';

            if (this.data.history.social_history != null) {
                this.alcohol = this.data.history.social_history.alcohol;
                this.smoking = this.data.history.social_history.smoking;
                this.smoking_type =
                    this.data.history.social_history.smoking.selected;
                this.alcohol_type =
                    this.data.history.social_history.alcohol.selected;
                if (this.smoking_type == 'Yes') {
                    this.no_of_packs =
                        this.data.history.social_history.smoking.data.number_of_packs_per_day;
                    this.no_of_years_smoked =
                        this.data.history.social_history.smoking.data.numbers_of_years_smoked;
                    this.year_of_quitting_smoke = null;
                    this.social_history_data +=
                        'Smoking :' +
                        this.smoking_type +
                        '\n' +
                        ' Number of Packs :' +
                        this.no_of_packs +
                        '\n Number of Years :' +
                        this.no_of_years_smoked +
                        '\n';
                } else if (this.smoking_type == 'Not Currently') {
                    this.no_of_packs = '';
                    this.no_of_years_smoked = '';
                    this.year_of_quitting_smoke = {
                        name: this.data.history.social_history.smoking.data
                            .year_of_quitting
                    };
                    this.social_history_data +=
                        'Smoking :' +
                        this.smoking_type +
                        '\n' +
                        ' Year of Quitting :' +
                        this.year_of_quitting_smoke.name +
                        '\n';
                } else if (this.smoking_type == 'Never') {
                    this.no_of_packs = '';
                    this.no_of_years_smoked = '';
                    this.year_of_quitting_smoke = null;
                    this.social_history_data +=
                        'Smoking :' + this.smoking_type + '\n';
                } else {
                    this.social_history_data += 'Smoking :' + 'N/A' + '\n';
                }
                this.social_history_data += '\n';
                if (this.alcohol_type == 'Yes') {
                    this.drinks_per_week =
                        this.data.history.social_history.alcohol.data.drinks_per_week;
                    this.year_of_quitting_alcohol = null;
                    this.social_history_data +=
                        'Alcohol :' +
                        this.alcohol_type +
                        ' \n Drinks per week :' +
                        this.drinks_per_week +
                        '\n';
                } else if (this.alcohol_type == 'Not Currently') {
                    this.drinks_per_week = '';
                    this.year_of_quitting_alcohol = {
                        name: this.data.history.social_history.alcohol.data
                            .year_of_quitting
                    };
                    this.social_history_data +=
                        'Alcohol :' +
                        this.alcohol_type +
                        '\n Year of Quitting :' +
                        this.year_of_quitting_alcohol.name +
                        '\n';
                } else if (this.alcohol_type == 'Never') {
                    this.drinks_per_week = '';
                    this.year_of_quitting_alcohol = null;
                    this.social_history_data +=
                        'Alcohol :' + this.alcohol_type + '\n';
                } else {
                    this.social_history_data += 'Alcohol :' + 'N/A' + '\n';
                }
                // this.social_history_data.replace("\n", "<br>");
            }

            if (this.data.history.family_history == null) {
                this.family_history_data = 'N/A';
            } else if (this.data.history.family_history.length == 0) {
                this.family_history_data = 'N/A';
            }
            // this.family_history_data = "";
            else if (this.data.history.family_history.length != null) {
                //this.members = this.view_health_data.data.history.family_history;
                this.preprocess_familyhistory(this.data.history.family_history);
            }
            for (let i = 0; i < this.members.length; i++) {
                if (this.members[i].data.length > 0) {
                    this.family_history_data += this.members[i].name;
                    for (let j = 0; j < this.members[i].data.length; j++) {
                        if (j == 0 && j == this.members[i].data.length - 1) {
                            this.family_history_data +=
                                ' : ' + this.members[i].data[j].name + '. \n';
                        } else if (j == 0) {
                            this.family_history_data +=
                                ' : ' + this.members[i].data[j].name;
                        } else if (j == this.members[i].data.length - 1) {
                            this.family_history_data +=
                                ', ' + this.members[i].data[j].name + '. \n';
                        } else
                            this.family_history_data +=
                                ', ' + this.members[i].data[j].name;
                    }
                }
            }
        }

        if (
            this.data.allergies_medications != null &&
            this.data.allergies_medications.medications_allergies_data != null
        ) {
            if (
                this.data.allergies_medications.medications_allergies_data
                    .medications != null &&
                this.data.allergies_medications.medications_allergies_data
                    .medications.length > 0
            ) {
                for (
                    let j = 0;
                    j <
                    this.data.allergies_medications.medications_allergies_data
                        .medications.length;
                    j++
                ) {
                    let times_per_day =
                        this.data.allergies_medications.medications_allergies_data.medications[
                            j
                        ].times_per_day.trim().length > 0
                            ? this.data.allergies_medications
                                .medications_allergies_data.medications[j]
                                .times_per_day
                            : 'N/A';
                    if (
                        !Boolean(
                            this.data.allergies_medications
                                .medications_allergies_data.medications[j][
                            'instructions'
                            ]
                        )
                    ) {
                        this.data.allergies_medications.medications_allergies_data.medications[
                            j
                        ]['instructions'] = '';
                    }
                    let instructions =
                        this.data.allergies_medications.medications_allergies_data.medications[
                            j
                        ].instructions.trim().length > 0
                            ? this.data.allergies_medications
                                .medications_allergies_data.medications[j]
                                .instructions
                            : 'N/A';
                    this.medication_data +=
                        'Medication Name : ' +
                        this.data.allergies_medications
                            .medications_allergies_data.medications[j].name +
                        '    Dose : ' +
                        this.data.allergies_medications
                            .medications_allergies_data.medications[j].dose +
                        '    Times Per Day : ' +
                        times_per_day +
                        '    Instructions : ' +
                        instructions +
                        ' . \n';
                }
            }
        }
        if (this.data.allergies_medications == null) {
            this.medication_data = 'N/A';
        } else if (
            this.data.allergies_medications.medications_allergies_data == null
        ) {
            this.medication_data = 'N/A';
        } else if (
            this.data.allergies_medications.medications_allergies_data
                .medications.length == 0
        ) {
            this.medication_data = 'N/A';
        }

        //allergies
        if (
            this.data.allergies_medications != null &&
            this.data.allergies_medications.medications_allergies_data != null
        ) {
            if (
                this.data.allergies_medications.medications_allergies_data
                    .allergies != null &&
                this.data.allergies_medications.medications_allergies_data
                    .allergies.length > 0
            ) {
                for (
                    let j = 0;
                    j <
                    this.data.allergies_medications.medications_allergies_data
                        .allergies.length;
                    j++
                ) {
                    this.allergy_data +=
                        'Allergy Name : ' +
                        this.data.allergies_medications
                            .medications_allergies_data.allergies[j].name +
                        '    Allergic Reaction : ' +
                        this.data.allergies_medications
                            .medications_allergies_data.allergies[j].reaction +
                        ' . \n';
                }
            }
        }
        if (this.data.allergies_medications == null) {
            this.allergy_data = 'N/A';
        } else if (
            this.data.allergies_medications.medications_allergies_data == null
        ) {
            this.allergy_data = 'N/A';
        } else if (
            this.data.allergies_medications.medications_allergies_data.allergies
                .length == 0
        ) {
            this.allergy_data = 'N/A';
        }
        if (this.data.apolloDiagnosticsCoupon == null) {
            this.apolloDiagnosticsCoupon = '';
        }
        else {
            this.isapollodiagnosticsline = true;
            this.apolloDiagnosticsCoupon = this.data.apolloDiagnosticsCoupon.couponId;
        }
        if (this.family_history_data.length == 0)
            this.family_history_data = 'N/A';

        if (this.condition_description.length == 0) {
            this.condition_description = 'N/A';
        }
        if (this.past_medical_history_data.length == 0) {
            this.past_medical_history_data = 'N/A';
        }
        if (this.past_medical_surgical_history.length == 0) {
            this.past_medical_surgical_history = 'N/A';
        }
        if (this.family_history_data.length == 0) {
            this.family_history_data = 'N/A';
        }
        if (this.social_history_data.length == 0) {
            this.social_history_data = 'N/A';
        }
        if (this.medication_data.length == 0) {
            this.medication_data = 'N/A';
        }
        if (this.allergy_data.length == 0) {
            this.allergy_data = 'N/A';
        }

        if (this.condition_description == null) {
            this.condition_description = 'N/A';
        }
        if (this.past_medical_history_data == null) {
            this.past_medical_history_data = 'N/A';
        }
        if (this.past_medical_surgical_history == null) {
            this.past_medical_surgical_history = 'N/A';
        }
        if (this.family_history_data == null) {
            this.family_history_data = 'N/A';
        }
        if (this.social_history_data == null) {
            this.social_history_data = 'N/A';
        }
        if (this.medication_data == null) {
            this.medication_data = 'N/A';
        }
        if (this.allergy_data == null) {
            this.allergy_data = 'N/A';
        }
    }
    DateFormat(date: Date): string {
        return formatDate(date, 'fullDate', 'en-us');
    }
}
